module.exports = __webpack_public_path__ + "static/media/module5.3e31ab92.png";